/* Estrani - de bolletjes onder de productfoto's laten meelopen met het
   kleurfilter. Door Claude gebouwd, veilig te verwijderen: haal de regel voor
   ai-galerijbolletjes uit snippets/ai-hoofd.liquid en gooi dit bestand weg.

   Wat er mis was. De productpagina toont alleen de foto's van de gekozen
   kleur; dat doet ai-productpagina.js door de andere op display:none te
   zetten. De bolletjes onder de foto komen uit het thema en wisten daar niets
   van. Bij de Puffer Jas met Steekzakken stonden er dus tien bolletjes onder
   vier foto's: je kon niet verder schuiven, en het aangeduide bolletje stond
   ergens in het midden van een rij waar je nooit kon geraken.

   Wat dit doet. Per diavoorstelling hoort bolletje i bij foto i. Is die foto
   weggefilterd, dan verbergen we het bolletje ook. Er blijven dus precies
   evenveel bolletjes over als er foto's te zien zijn, en het aangeduide
   bolletje staat altijd tussen de zichtbare. De aria-label telt mee: "Dia 2
   van 4" in plaats van "Dia 8 van 10".

   Aan de diavoorstelling zelf raken we niet. Zet je het kleurfilter ooit uit,
   dan staat er nergens nog ai-pp-weg en zet dit bestand alles vanzelf terug
   zoals het thema het had (de oorspronkelijke label bewaren we daarvoor).

   De kijker let ook op class, want het filter wisselt klassen op bestaande
   elementen - dat is geen toevoeging aan de pagina en zou een gewone kijker
   dus ontgaan. Een korte wachttijd bundelt de vele klassewissels van een
   diavoorstelling tot een ronde. */

(function () {
  'use strict';
  if (window.__aiGalerijBolletjes) return;
  window.__aiGalerijBolletjes = true;

  var BEZIG = false;
  var TIMER = null;

  function doeLijst(lijst) {
    var comp = lijst.closest ? lijst.closest('slideshow-component') : null;
    if (!comp) return;
    var slides = comp.querySelectorAll('.product-media-container');
    var dots = lijst.querySelectorAll('button.slideshow-control');
    /* Alleen als bolletje en foto een op een overeenkomen. Klopt dat niet,
       dan is dit een andere soort diavoorstelling en blijven we eraf. */
    if (!slides.length || slides.length !== dots.length) return;

    var i, zichtbaar = 0;
    for (i = 0; i < slides.length; i++) {
      if (!slides[i].classList.contains('ai-pp-weg')) zichtbaar++;
    }
    if (zichtbaar === 0) return; /* vangnet: liever alles dan niets */

    var alles = zichtbaar === slides.length;
    var n = 0;
    for (i = 0; i < dots.length; i++) {
      var dot = dots[i];
      if (dot.dataset.aiLabel === undefined) {
        dot.dataset.aiLabel = dot.getAttribute('aria-label') || '';
      }
      var weg = slides[i].classList.contains('ai-pp-weg');
      var wil = weg ? 'none' : '';
      if (dot.style.display !== wil) dot.style.display = wil;
      if (weg) continue;
      n++;
      var label = alles ? dot.dataset.aiLabel : 'Dia ' + n + ' van ' + zichtbaar;
      if (dot.getAttribute('aria-label') !== label) dot.setAttribute('aria-label', label);
    }
  }

  function draai() {
    if (BEZIG) return;
    BEZIG = true;
    try {
      var lijsten = document.querySelectorAll('.slideshow-controls__dots');
      for (var i = 0; i < lijsten.length; i++) doeLijst(lijsten[i]);
    } catch (e) { /* nooit de pagina breken */ }
    BEZIG = false;
  }

  function plan() {
    if (TIMER) return;
    TIMER = setTimeout(function () { TIMER = null; draai(); }, 50);
  }

  draai();
  new MutationObserver(plan).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', draai, { once: true });
  }
})();
